import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ClientQaspPage from "@/pages/client/ClientQaspPage";

export const Route = createFileRoute("/client/qasp")({
  head: () => pageHead("Client · Qasp", "AKIVA client · qasp portal.", "/client/qasp", true),
  component: ClientQaspPage,
});
